import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import RefreshIcon from '@mui/icons-material/Refresh';
import {Button, Stack, StackProps, Typography} from '@mui/material';
import {ReactNode} from 'react';
import EmptyMessage from './EmptyMessage.tsx';

interface ErrorMessageProps {
  title?: string;
  children?: ReactNode;
  rootProps?: StackProps;
  componentName?: string;
  onRetry?: (...args: unknown[]) => void;
}

const ErrorMessage = ({
  title = 'Houston, we have a problem...',
  children,
  rootProps = {},
  componentName = 'page',
  onRetry,
}: ErrorMessageProps) => {
  return (
    <EmptyMessage
      icon={<ErrorOutlineOutlinedIcon color="error" />}
      title={title}
      {...rootProps}
    >
      {children}

      <Typography gutterBottom>
        Try reloading the {componentName} or let us know what happened.
      </Typography>

      <Stack
        direction="row"
        sx={{
          alignItems: 'center',
          gap: 2,
          justifyContent: 'center',
          marginBlockStart: 2,
        }}
      >
        {onRetry && (
          <Button
            size="small"
            color="primary"
            variant="outlined"
            onClick={onRetry}
            startIcon={<RefreshIcon />}
          >
            Reload
          </Button>
        )}

        <Button
          size="small"
          color="primary"
          variant="contained"
          href="https://support.planet.com/hc/en-us/requests/new"
          target="_blank"
          rel="noreferrer noopener"
          endIcon={<OpenInNewIcon fontSize="small" />}
        >
          Report Issue
        </Button>
      </Stack>
    </EmptyMessage>
  );
};

export default ErrorMessage;
